import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static values = {
    cookieName: String,
    dismissible: Boolean,
  };

  // The dismissal check runs client-side because these banners render inside
  // pages that are action-cached for signed-out visitors. A server-side check
  // would be baked into the shared cached HTML and ignore the visitor's cookie.
  connect() {
    if (this.dismissibleValue && Cookies.get(this.cookieNameValue)) {
      this.element.remove();
    } else {
      this.element.style.removeProperty("display");
    }
  }

  dismiss(event) {
    // Keep the click off the banner's followLink action on the container.
    event.stopPropagation();

    Cookies.set(this.cookieNameValue, true, {
      expires: 14,
    });
    this.element.remove();
  }

  followLink() {
    window.location = this.element.dataset.href;
  }
}
